import { useContext, useState } from "react"
import PropTypes from "prop-types"
import { AutoAwesome } from "@mui/icons-material"
import Button from "components/material/button"
import { useResourceCurrency } from "resources/currencies"
import { useModelMetadata } from "resources/models"
import { usePositionSetMetadata } from "resources/position-sets"
import AiTeammate from "../.."
import "./style.scss"

export default function AiToggleButton({ context }) {
  const [isOpen, setIsOpen] = useState(false)
  const dashboardContext = useContext(context)
  const { isPreferencesLoaded, modelId, instrument, base } = dashboardContext

  const [modelMetadata] = useModelMetadata(modelId)
  const [resourceMetadata] = usePositionSetMetadata(modelId, instrument, modelMetadata?.availability?.currentDate)
  const [benchmarkMetadata] = usePositionSetMetadata(modelId, base, modelMetadata?.availability?.currentDate)
  const [currency] = useResourceCurrency(modelId, instrument)

  function handleToggle() {
    setIsOpen(!isOpen)
  }

  function handleDrawerClose() {
    setIsOpen(false)
  }

  return <>
    <Button
      onClick={handleToggle}
      size="medium"
      color="primary"
      variant="contained"
      className="ai-toggle-button"
      disabled={!isPreferencesLoaded}
      tooltip={`AI Teammate${!isPreferencesLoaded ? " (Loading...)" : ""}`}
    >
        <AutoAwesome className="ai-toggle-button-icon" />
    </Button>
    <AiTeammate
      isOpen={isOpen}
      onClose={handleDrawerClose}
      modelId={dashboardContext.modelId}
      instrument={dashboardContext.instrument}
      base={dashboardContext.base}
      modelMetadata={modelMetadata}
      resourceMetadata={resourceMetadata}
      benchmarkMetadata={benchmarkMetadata}
      currency={currency}
      startDate={dashboardContext.startDate}
      endDate={dashboardContext.endDate}
    />
  </>
}

AiToggleButton.propTypes = {
  context: PropTypes.object.isRequired,
}
